(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-gallery"] && !Shopify.designMode) return;
  try {
    
/** code by squarestylist.com — standoutshopify.com **/

(function () {
  function initScrollEditorial(section) {
    const track    = section.querySelector('[data-track]');
    const cards    = Array.from(section.querySelectorAll('[data-card-index]'));
    const bgs      = Array.from(section.querySelectorAll('[data-bg-index]'));
    const cardCount = parseInt(section.dataset.cardCount, 10) || cards.length;

    if (!track || !cards.length) return;

    let activeIdx  = 0;
    let rafId      = null;

    function setActiveBg(idx) {
      activeIdx = idx;
      bgs.forEach(function(bg, i) {
        bg.classList.toggle('is-active', i === idx);
      });
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;

        const sectionRect = section.getBoundingClientRect();
        const sectionH    = section.offsetHeight;
        const viewH       = window.innerHeight;

        // Progress 0→1 through the pinned section
        const scrolled = Math.max(0, Math.min(1, -sectionRect.top / (sectionH - viewH)));

        // Total horizontal distance to travel
        const viewportEl = section.querySelector('.sqsh-scroll-editorial__viewport');
        const trackW     = track.scrollWidth;
        const viewportW  = viewportEl ? viewportEl.offsetWidth : window.innerWidth;
        const maxSlide   = Math.max(0, trackW - viewportW);
        const translateX = scrolled * maxSlide;

        track.style.transform = 'translateX(-' + translateX + 'px)';

        // Find which card's center is closest to 1/3 from left of viewport
        // (left-third feels more natural for "active" on a horizontal reveal)
        const triggerX = translateX + viewportW * 0.33;
        let closest = 0;
        let closestDist = Infinity;
        const cardsContainer = track.querySelector('[data-cards]');
        const cardsOffset = cardsContainer ? cardsContainer.offsetLeft : 0;

        cards.forEach(function(card, i) {
          const cardCenter = cardsOffset + card.offsetLeft + card.offsetWidth / 2;
          const dist = Math.abs(cardCenter - triggerX);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        setActiveBg(closest);
      });
    }

    // Only run pinned scroll on desktop
    if (window.matchMedia('(min-width: 768px)').matches) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll(); // init position
    }

    // Cleanup on section unload (theme editor)
    section._sqshCleanup = function() {
      window.removeEventListener('scroll', onScroll);
    };
  }

  function init() {
    document.querySelectorAll('.sqsh-scroll-editorial').forEach(initScrollEditorial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor section events
  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.sqsh-scroll-editorial');
    if (section) initScrollEditorial(section);
  });
  document.addEventListener('shopify:section:unload', function(e) {
    var section = e.target.querySelector('.sqsh-scroll-editorial');
    if (section && section._sqshCleanup) section._sqshCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-the-team-tabs"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  class SqshMeetTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        tab.classList.toggle('is-active', selected);
        if (this.panels[i]) this.panels[i].hidden = !selected;
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = index === last ? 0 : index + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = index === 0 ? last : index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(next);
      this.tabs[next].focus();
    }
  }

  if (!customElements.get('sqsh-meet-tabs')) {
    customElements.define('sqsh-meet-tabs', SqshMeetTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-scroll"] && !Shopify.designMode) return;
  try {
    
/** code by squarestylist.com — standoutshopify.com **/
class SqshHorizontalScroll extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.sqsh-hscroll__viewport');
    this.track = this.querySelector('[data-track]');
    this.cards = Array.from(this.querySelectorAll('[data-card]'));
    this.bgLayers = Array.from(this.querySelectorAll('.sqsh-hscroll__bg-layer'));
    this.counter = this.querySelector('[data-counter-current]');
    this.activeIndex = -1;
    this.ticking = false;
    this.mode = null;

    if (!this.viewport || !this.track || this.cards.length === 0) return;

    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.applyMode = this.applyMode.bind(this);

    this.applyMode();
    if (this.reduce.addEventListener) {
      this.reduce.addEventListener('change', this.applyMode);
    }
  }

  applyMode() {
    this.teardown();
    if (this.reduce.matches) {
      this.enableNative();
    } else {
      this.enablePinned();
    }
  }

  enablePinned() {
    this.mode = 'pinned';
    this.classList.add('sqsh-hscroll--pinned');
    this.measure();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.update();
  }

  enableNative() {
    this.mode = 'native';
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
          this.setActive(parseInt(entry.target.dataset.index, 10));
        }
      });
    }, { root: this.viewport, threshold: [0.55, 0.8] });
    this.cards.forEach((card) => this.io.observe(card));
    this.setActive(0);
  }

  measure() {
    /* Center the first and last cards exactly: leading/trailing space = half the
       leftover width beside one card. Pixel-precise, so it ignores scrollbar quirks. */
    const cardW = this.cards[0].offsetWidth;
    const edge = Math.max(0, (this.viewport.clientWidth - cardW) / 2);
    this.track.style.paddingLeft = edge + 'px';
    this.track.style.paddingRight = edge + 'px';

    this.maxX = Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
    this.style.height = (this.viewport.offsetHeight + this.maxX) + 'px';
  }

  onResize() {
    this.measure();
    this.update();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    if (this.mode !== 'pinned') return;
    const rect = this.getBoundingClientRect();
    const scrollable = this.offsetHeight - this.viewport.offsetHeight;
    let progress = scrollable > 0 ? (-rect.top / scrollable) : 0;
    progress = Math.min(1, Math.max(0, progress));

    const x = progress * this.maxX;
    this.track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';

    const center = x + this.viewport.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    for (let i = 0; i < this.cards.length; i++) {
      const card = this.cards[i];
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const dist = Math.abs(cardCenter - center);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    this.setActive(best);
  }

  setActive(index) {
    if (index === this.activeIndex || index < 0) return;
    this.activeIndex = index;
    for (let i = 0; i < this.bgLayers.length; i++) {
      this.bgLayers[i].classList.toggle('is-active', i === index);
    }
    if (this.counter) {
      this.counter.textContent = String(index + 1).padStart(2, '0');
    }
  }

  teardown() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (this.io) { this.io.disconnect(); this.io = null; }
    this.classList.remove('sqsh-hscroll--pinned');
    this.style.removeProperty('height');
    if (this.track) {
      this.track.style.transform = '';
      this.track.style.paddingLeft = '';
      this.track.style.paddingRight = '';
    }
    this.activeIndex = -1;
  }

  disconnectedCallback() {
    this.teardown();
    if (this.reduce && this.reduce.removeEventListener) {
      this.reduce.removeEventListener('change', this.applyMode);
    }
  }
}

if (!customElements.get('sqsh-horizontal-scroll')) {
  customElements.define('sqsh-horizontal-scroll', SqshHorizontalScroll);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-circle"] && !Shopify.designMode) return;
  try {
    
  class MaterialsTabs extends HTMLElement {
    constructor() {
      super();
      this.triggers = [];
      this.panels = [];
    }

    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.triggers.length === 0) return;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleClick.bind(this));
        trigger.addEventListener('keydown', this.handleKeydown.bind(this));
      });
    }

    handleClick(event) {
      const trigger = event.currentTarget;
      this.activate(trigger);
    }

    handleKeydown(event) {
      const currentIndex = this.triggers.indexOf(event.currentTarget);
      let nextIndex = null;

      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          nextIndex = (currentIndex + 1) % this.triggers.length;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          nextIndex = (currentIndex - 1 + this.triggers.length) % this.triggers.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.triggers.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      const nextTrigger = this.triggers[nextIndex];
      this.activate(nextTrigger);
      nextTrigger.focus();
    }

    activate(activeTrigger) {
      const activeIndex = activeTrigger.dataset.tabIndex;

      this.triggers.forEach((trigger) => {
        const isActive = trigger === activeTrigger;
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        trigger.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tabIndex === activeIndex;
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('materials-tabs')) {
    customElements.define('materials-tabs', MaterialsTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
